import React, { useState, useCallback, useMemo } from 'react';
import Start from '../Start';
import Scenario from '../Scenario';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';

const Views = ({ content }) => {
  const { scenarios } = content;

  const hasOneScenario = scenarios.length === 1;
  const startScenario = hasOneScenario ? scenarios[0] : null;
  const startStep = hasOneScenario ? startScenario.steps[0] : null;

  const [ended, setEnded] = useState(false);
  const [currentScenario, setCurrentScenario] = useState(startScenario);
  const [currentStep, setCurrentStep] = useState(startStep);

  const scenarioForStep = (step) => {
    return scenarios.find((scenario) => Array.isArray(scenario.steps) && scenario.steps.includes(step));
  };

  const steps = useMemo(() => {
    return scenarios.reduce((flatSteps, scenario) => {
      if (!Array.isArray(scenario.steps)) return flatSteps;
      return flatSteps.concat(scenario.steps);
    }, []);
  }, [scenarios]);

  const findStep = (key) => {
    return steps.find((step) => step.key === key);
  };

  const triggerEnd = useCallback(() => setEnded(true), []);

  const triggerRestart = useCallback(() => {
    setEnded(false);
    setCurrentScenario(null);
    return;
  }, []);

  const setStep = (stepOrKey) => {
    const step = isString(stepOrKey) ? findStep(stepOrKey) : stepOrKey;
    setCurrentStep(step);
    setCurrentScenario(scenarioForStep(step));
    setEnded(false);
  };

  const setScenario = (scenario) => {
    setStep(scenario.steps[0]);
  };

  const currentStepIsLastStep = steps.indexOf(currentStep) == steps.length - 1;

  const advance = () => {
    const nextStep = steps[steps.indexOf(currentStep) + 1];
    if (!nextStep) {
      setStep(steps[0]);
      return;
    }
    setStep(nextStep);
  };

  const rewind = () => {
    const previousStep = steps[steps.indexOf(currentStep) - 1];
    if (!previousStep) {
      setStep(steps[steps.length - 1]);
      return;
    }
    setStep(previousStep);
  };

  // If the widget logic changes to be not looping, these vars will come in
  // handy.
  const canAdvance = true;
  const canRewind = true;

  const viewProps = {
    triggerEnd,
    triggerRestart,
    steps,
    setStep,
    setScenario,
    advance,
    rewind,
    canAdvance,
    canRewind,
    scenarios,
    content,
    currentScenario,
    currentStep,
    currentStepIsLastStep,
    hasOneScenario,
    ended
  };

  if (!currentScenario) return <Start {...viewProps} />;
  if (currentScenario) return <Scenario {...viewProps} />;
};

Views.propTypes = {
  content: PropTypes.shape({
    scenarios: PropTypes.array,
    startScreen: PropTypes.string,
    startVideo: PropTypes.strting,
  }),
};

export default Views;
